import React, { useState, useCallback, useRef } from 'react';
import { useQuestionnaireContext } from '@/components/Questionnaire/QuestionnaireProvider';
import { Questionnaire } from '@/typings/Questionnaire';
import Button from '@/components/DesignLibrary/Button';
import { useToast } from '@/hooks';
import getListOrTableField from '@helpers/getListOrTableField';
import trackEvents from '@/helpers/trackEvents';
import formValuesToResponses from '../helpers/formValuesToResponses';

type Props = {
  formData: Questionnaire.Questionnaire;
};

const SaveButton: React.FC<Props> = ({ formData }) => {
  trackEvents.track('render - SaveButton');
  const toast = useToast();
  const {
    formMethods,
    fieldsById,
    getFieldSource,
    getAiRequestId,
    onSubmit,
  } = useQuestionnaireContext();

  const [isSaving, setIsSaving] = useState(false);

  const onSubmitRef = useRef(onSubmit);
  onSubmitRef.current = onSubmit;

  const handleSave = useCallback(async (): Promise<void> => {
    setIsSaving(true);
    const asResponses = formValuesToResponses(
      formMethods.getValues(),
      getFieldSource,
      getAiRequestId,
      formData.sections,
      (fieldId: string) => Boolean(getListOrTableField({ fieldId, fieldsById })),
    );
    const success = await onSubmitRef.current(asResponses, false);

    if (success) {
      toast(useToast.ToastTypeVariants.SUCCESS, 'Responses saved successfully!');
    }

    setIsSaving(false);
  }, [toast, formData.sections, formMethods, fieldsById, getFieldSource, getAiRequestId]);

  return (
    <Button
      loading={isSaving}
      variant="secondary"
      size="md"
      onClick={handleSave}
    >
      Save and complete later
    </Button>
  );
};

export default SaveButton;